import { render, staticRenderFns } from "./closeBlack.vue?vue&type=template&id=7c381940&"
import script from "./closeBlack.vue?vue&type=script&lang=ts&"
export * from "./closeBlack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports